const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => ({
    root: {
        width: '90%'
    },
    textIcon: {
        fontSize: 180,
        lineHeight: 1,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontWeight: 'bold'
    },
    imageIcon: {
        width: '140px',
        height: '125px',
        marginTop: 30,
        marginBottom: theme.spacing(1),
    },
    title: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
    },
    subTitle: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontSize: '1.2rem'
    },
    buttonContainer: {
        height: 130,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    footer: {
        marginTop: 'auto',
        marginBottom: '20px',
    },
}));

export default useStyles;